import React from "react";
import { Grid, Box, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import { ModernLiquidTable, LiquidIconButton } from "../../../../components/modern-table";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { getStaff, deleteStaff } from "../../../../api/user";
import exportToExcel from "../../../../utils/exportToExcel";


export default function StaffsPage(props) {
  const [staffRows, setStaffRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const authToken = useSelector(({auth}) => auth.authToken);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = await getStaff(authToken);
      if (data) {
        setStaffRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [authToken]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (rowData) => {
    setLoading(true);
    try {
      await deleteStaff(authToken, rowData.id);
      await fetchData(); // Refresh data after delete
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleExport = (columns, data) => {
    const exportData = data.map((staff) => ({
      Nama: staff.name,
      Email: staff.email,
      Cawangan: staff.branch,
    }));
    exportToExcel(exportData);
  };

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "name", title: "Nama", width: 300 },
    {
      field: "email",
      title: "E-mel",
    },
    { field: "branch", title: "Cawangan Gema" },
    {
      field: "actions",
      title: "Tindakan",
      width: 100,
      render: (rowData) => (
        <Tooltip title="Padam">
          <LiquidIconButton
            size="small"
            onClick={() => handleDelete(rowData)}
          >
            <DeleteIcon />
          </LiquidIconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <span className="kt-section__sub">
                Senarai staff yang aktif untuk menguruskan sistem.
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={staffRows}
              title={`Senarai Staff: ${staffRows.length}`}
              loading={loading}
              onRefresh={fetchData}
              exportFunction={handleExport}
              emptyStateMessage="Tiada staff berdaftar"
              options={{
                selection: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
